import { Account } from '@adsk/alloy-provider';

/**
 * This method returns the account URL based on a given account & the current service type.
 * @return {string}
 */
export default (account: Account, currentServiceType?: string) => {
  const services = account?.services || [];
  const accountService = services.find(
    (s) => s.service_type === currentServiceType,
  );

  return accountService?.account_url || account.account_url;
};
